import { Card, Container } from 'react-bootstrap';

export default function DataProcessingAgreement() {
  return (
    <div className="bg-light min-vh-100 py-5">
      <Container>
        <Card className="shadow-sm">
          <Card.Body className="p-4 p-md-5">
            <h1 className="h3 fw-bold mb-3">Data Processing Agreement</h1>
            <p className="text-muted mb-4">
              This Data Processing Agreement ("DPA") forms part of the agreement
              between <strong>SupplyPassport OÜ</strong> and the customer entity
              using the SupplyPassport platform. It governs the processing of
              personal data by SupplyPassport on behalf of the customer in
              connection with the services available at
              <strong> SupplyPassport.app</strong>.
            </p>

            <h2 className="h5 fw-semibold mt-4">1. Roles of the Parties</h2>
            <p>
              For the purposes of applicable data protection law, including the
              GDPR, the customer acts as the <strong>data controller</strong>
              and SupplyPassport OÜ acts as the <strong>data processor</strong>
              to the extent we process personal data on the customer&apos;s
              behalf.
            </p>

            <h2 className="h5 fw-semibold mt-4">2. Subject Matter</h2>
            <p>
              SupplyPassport provides a software platform for supplier
              compliance, risk management, assessments, and profile sharing.
              Personal data may be processed as necessary to host, store,
              organize, analyze, and present customer-submitted information
              within the service.
            </p>

            <h2 className="h5 fw-semibold mt-4">3. Categories of Data</h2>
            <p>
              Depending on how the customer uses the service, processed data may
              include:
            </p>
            <ul>
              <li>
                Account and identity data, such as names and email addresses.
              </li>
              <li>
                Supplier and contact information entered into the platform.
              </li>
              <li>
                Assessment responses, uploaded documents, and audit metadata.
              </li>
              <li>
                Technical and usage information required to operate the service.
              </li>
            </ul>

            <h2 className="h5 fw-semibold mt-4">4. Purpose and Duration</h2>
            <p>
              SupplyPassport processes personal data only for the purpose of
              delivering the contracted services, providing support, securing
              the platform, and complying with documented customer instructions.
              Processing continues for the duration of the service relationship
              unless otherwise required by law.
            </p>

            <h2 className="h5 fw-semibold mt-4">5. Processor Obligations</h2>
            <p>SupplyPassport will:</p>
            <ul>
              <li>
                Process personal data only on documented instructions from the
                customer.
              </li>
              <li>
                Ensure personnel with access to personal data are bound by
                confidentiality obligations.
              </li>
              <li>
                Implement appropriate technical and organizational security
                measures.
              </li>
              <li>
                Assist the customer with reasonable requests related to data
                subject rights and compliance.
              </li>
              <li>
                Notify the customer without undue delay of confirmed personal
                data breaches affecting customer data.
              </li>
            </ul>

            <h2 className="h5 fw-semibold mt-4">6. Subprocessors</h2>
            <p>
              SupplyPassport may engage subprocessors to support hosting,
              infrastructure, communications, analytics, and payment-related
              operations. SupplyPassport remains responsible for ensuring such
              subprocessors are bound by data protection obligations consistent
              with this DPA.
            </p>

            <h2 className="h5 fw-semibold mt-4">7. International Transfers</h2>
            <p>
              Where personal data is transferred outside the EEA, SupplyPassport
              will ensure an appropriate transfer mechanism is in place, such as
              adequacy decisions or the European Commission&apos;s Standard
              Contractual Clauses, where required.
            </p>

            <h2 className="h5 fw-semibold mt-4">
              8. Deletion or Return of Data
            </h2>
            <p>
              Upon termination of the services, SupplyPassport will delete or
              return customer personal data in accordance with the customer
              agreement, unless retention is required under applicable law.
            </p>

            <h2 className="h5 fw-semibold mt-4">
              9. Audit and Information Rights
            </h2>
            <p>
              Upon reasonable request, SupplyPassport will provide information
              necessary to demonstrate compliance with this DPA and applicable
              data protection obligations, subject to reasonable confidentiality
              and security safeguards.
            </p>

            <h2 className="h5 fw-semibold mt-4">10. Contact</h2>
            <p className="mb-0">
              For questions regarding this Data Processing Agreement or data
              protection matters, please contact:
              <br />
              <strong>Email:</strong> info@supplypassport.co
              <br />
              <strong>Address:</strong> SupplyPassport OÜ, Tallinn, Estonia
            </p>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}
